export default __webpack_public_path__ + "static/media/total_Orders.a16c9ba2.svg";